import { Link } from 'gatsby'
import React from 'react'
import styles from './BannerAptitudeTest.module.scss'

const BannerAptitudeTest = () => {
  return (
    <div className={styles.main}>
      <div className={`${styles.container} py-5 `}>
        <div className={`${styles.inner} py-3 px-1`}>
          <h1 className="mb-5">
            <strong>
              {/* Take one of our practice{' '}
              <Link to="/practice-aptitude-tests">
              aptitude tests
              </Link>: */}
              Practice Aptitude Tests
            </strong>{' '}
            {/* numerical, verbal, inductive, abstract, cognitive, deductive,
            logical, mechanical and Watson Graser. */}
          </h1>
          <p className="text-center">
            Each {/* <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY"> */}
            test {' '}
            {/* </a>{' '} */}
            is free to take and includes <strong>
              questions, answers
            </strong> and{' '}
            <strong>
              <em>fully explained solutions</em>
            </strong>
            . After you take a{' '}
            {/* <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY"> */}
            test
            {/* </a> */}, write a comment below it to let others know how you
            found it.
          </p>
        </div>
      </div>
    </div>
  )
}

export default BannerAptitudeTest
